import { render, staticRenderFns } from "./m-gc-step-skirt.vue?vue&type=template&id=44dea59a&scoped=true&"
import script from "./m-gc-step-skirt.vue?vue&type=script&lang=js&"
export * from "./m-gc-step-skirt.vue?vue&type=script&lang=js&"
import style0 from "./m-gc-step-skirt.vue?vue&type=style&index=0&id=44dea59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dea59a",
  null
  
)

export default component.exports